import MinusIcon from "@/components/icons/MinusIcon";
import AddIcon from "@/components/icons/AddIcon";
import Link from "next/link";

const QuickLinks = ({ t, active, setActive }) => {
  return (
    <div className="col-span-full md:col-span-6 lg:col-span-2">
      <h2 className="hidden font-bold uppercase whitespace-nowrap md:block">
        {t("Shopping @ Abdulwahed")}
      </h2>
      <div
        onClick={() =>
          setActive(active === "quick-links" ? null : "quick-links")
        }
        className="flex items-center justify-between text-white cursor-pointer md:hidden"
      >
        <h2 className="font-bold uppercase whitespace-nowrap">
          {t("Shopping @ Abdulwahed")}
        </h2>
        {!active || active !== "quick-links" ? (
          <AddIcon className="size-3" />
        ) : (
          <MinusIcon className="size-3" />
        )}
      </div>
      <div
        className={`${
          active !== "quick-links" ? "hidden" : "flex"
        } mt-3 md:flex flex-col md:mt-6 max-sm:*:mb-3 *:mb-2 last:*:mb-0`}
      >
        <Link
          href="/home-delivery"
          className="cursor-pointer whitespace-nowrap"
        >
          {t("Home Delivery")}
        </Link>
        <Link
          href="/maintenance"
          className="cursor-pointer whitespace-nowrap"
        >
          {t("Maintenance")}
        </Link>
        <Link
          prefetch={false}
          href="/terms-and-conditions"
          className="whitespace-nowrap"
        >
          {t("Terms & Conditions")}
        </Link>
        <Link
          prefetch={false}
          href="/privacy-policy"
          className="whitespace-nowrap"
        >
          {t("Privacy Policy")}
        </Link>
        <Link prefetch={false} href="/faq" className="whitespace-nowrap">
          {t("FAQ")}
        </Link>
        <Link
          prefetch={false}
          href="/pay-as-installment"
          className="whitespace-nowrap"
        >
          {t("Pay as installment")}
        </Link>
      </div>
    </div>
  );
};

export default QuickLinks;
